export default "__VITE_ASSET__e877731e__"